module.exports = __webpack_public_path__ + "img/congrat.d18a6ffb.png";